import { Component, Input, SimpleChanges } from '@angular/core';
import { NavController } from 'ionic-angular';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';



@Component({
	selector: 'Zusatzinformationen',
	templateUrl: 'Zusatzinformationen.html'
})
export class ZusatzinformationenComponent {

	@Input()
	zusatzinformationen : string = "";


	html : SafeHtml = ""; // Das wird dargestellt.


	/**	=== Visionet(sl) ==========
	 *	Beim Aufruf des Konstruktors ist der Eingangs-Parameter `zusatzinformationen` noch undefiniert.
	 *	Wir brauchen den Konstruktor nur um den `DomSanitizer` zu erhalten.
	 */
	constructor(public navCtrl: NavController, public sanitizer: DomSanitizer) {
	}


	/**	=== Visionet(sl) ==========
	 *	Bei jeder Änderung des Eingangs-Parameters `zusatzinformationen`  in der übergeordneten Seite wird
	 *	die Funktion `ngOnChanges`  aufgerufen und enthält im Parameter `changes` den geänderten Wert.
	 *	Dieser Wert ist aber ein ungültiges HTML weil dort das Attribut `checklisteId` im <a>-Tag vorkommt.
	 *	In diesem Attribut steht die ID der Ziel-Checkliste.
	 *	Wir müssen dem Programm beibringen, dass das schon in Ordnung ist und erklären, dass es sich um
	 *	sicheres HTML (`SafeHtml`) handelt.
	 *	Sicheres HTML aus einem String macht man per `DomSanitizer`
	 *	Das alleine reicht aber noch nicht. Das <a>-Tag verweist ja nicht direkt per href-Attribut auf eine Zielseite.
	 *	Der Klick auf muss abgefangen werden und per `NavController` zur Ziel-Checklsite navigiert werden.
	 *	Dazu (siehe HTML) wird im <div>-Tag über das Attribut `cklickHandler` eine `@Directive` verankert.
	 *	Die `@Directive` registreiert dann `cklickHandler` als Selektor und überall wo der auftaucht
	 *	schlägt die Direktive dan zu.
	 */
	ngOnChanges(changes: SimpleChanges) : void {
		this.html = this.sanitizer.bypassSecurityTrustHtml(changes.zusatzinformationen.currentValue);
	}

}



// WEBPACK FOOTER //
// ./src/components/Zusatzinformationen/Zusatzinformationen.ts